import { SelectedAgency, SelectedPlace } from "@/interfaces/searchBlock";

export const isAgencyPlace = (
  selectedPlace: SelectedPlace
): selectedPlace is SelectedAgency => selectedPlace.isAgency;
